import { Button, DatePicker, Form, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { EmployeeShiftHistorySetup, loadAllShift } from "../../../redux/rtk/features/shift/shiftSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";

const ShiftEditSinglePopup = ({ data, setLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const masterData = useSelector((state) => state.masters.masters);
  const Option = Select;
 const shiftData = useSelector((state)=> state?.shift?.list)
  useEffect(() => {
     dispatch(loadAllShift())
    dispatch(getAllMaster());
    if (isModalOpen && data) {
      form.setFieldsValue({
        ShiftId: data.ShiftId,
        EffectedFrom: data.EffectedFrom ? dayjs(data.EffectedFrom) : null,
        EffectedTo: data.EffectedTo ? dayjs(data.EffectedTo) : null,
        
      });
    }
  }, [isModalOpen, data, form, dispatch]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

    const onFinish = async (values) => {
      try {
        setLoading(true);
        const response = await dispatch(EmployeeShiftHistorySetup({
          ...values,
          ShiftHistoryId:data.ShiftHistoryId,
          EmployeeId: id,
          DataStatus: 1,
        }));
        if (response.payload.message === "success") {
          dispatch(loadSingleStaff(id));
          setIsModalOpen(false);
          form.resetFields();
        }
      } catch (error) {
        // console.error("Error adding shift history:", error);
      } finally {
        setLoading(false);
      }
    };

  return (
    <>
      <Button onClick={showModal} className="mr-2">
        Edit
      </Button>
      <Modal
        title="Edit Shift"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="editShift"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="Shift Name"
            name="ShiftId"
            rules={[{ required: true, message: "Please select a shift!" }]}
          >
            <Select 
              placeholder="Select shift" 
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {shiftData?.map((shift) => (
                <Option key={shift.ShiftId} value={shift.ShiftId}>
                  {shift.ShiftName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Effective From"
            name="EffectedFrom"
            rules={[{ required: true, message: "Please enter the effective date!" }]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item
            label="Effective To"
            name="EffectedTo"
            // rules={[{ required: true, message: "Please enter the effective date!" }]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ShiftEditSinglePopup;